import React from 'react';
import InputIconByKey from '../Input/InputIconByKey';

interface InfoCardProps {
  label: string;
  value?: string | number;
  iconKey?: string;
  placeholder?: string;
}

const InfoCard: React.FC<InfoCardProps> = ({
  label,
  value,
  iconKey,
  placeholder,
}) => {
  const displayValue =
    value !== undefined && value !== null && value !== ''
      ? value
      : placeholder || '—';

  return (
    <div className="mb-4">
      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
        {label}
      </label>

      <div className="flex w-full overflow-hidden rounded border border-stroke dark:border-form-strokedark">
        {iconKey && (
          <div className="flex h-12 w-12 items-center justify-center bg-gray px-4 dark:bg-form-strokedark">
            <InputIconByKey iconKey={iconKey} />
          </div>
        )}

        <div className="w-full px-5 py-3 text-sm text-black dark:text-white bg-transparent dark:bg-form-input">
          {displayValue}
        </div>
      </div>
    </div>
  );
};

export default InfoCard;
